/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';

/**
 * 
 * @export
 * @interface BrokerConsultantInformationViewModel
 */
export interface BrokerConsultantInformationViewModel {
    /**
     * 
     * @type {string}
     * @memberof BrokerConsultantInformationViewModel
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerConsultantInformationViewModel
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerConsultantInformationViewModel
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerConsultantInformationViewModel
     */
    telephoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerConsultantInformationViewModel
     */
    sanpayCode: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerConsultantInformationViewModel
     */
    institutionAgentCode: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof BrokerConsultantInformationViewModel
     */
    telephoneNumberCountryCode: IAPCOUNTRY;
}

/**
 * Check if a given object implements the BrokerConsultantInformationViewModel interface.
 */
export function instanceOfBrokerConsultantInformationViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "surname" in value;
    isInstance = isInstance && "emailAddress" in value;
    isInstance = isInstance && "telephoneNumber" in value;
    isInstance = isInstance && "sanpayCode" in value;
    isInstance = isInstance && "institutionAgentCode" in value;
    isInstance = isInstance && "telephoneNumberCountryCode" in value;

    return isInstance;
}

export function BrokerConsultantInformationViewModelFromJSON(json: any): BrokerConsultantInformationViewModel {
    return BrokerConsultantInformationViewModelFromJSONTyped(json, false);
}

export function BrokerConsultantInformationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerConsultantInformationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['FirstName'],
        'surname': json['Surname'],
        'emailAddress': json['EmailAddress'],
        'telephoneNumber': json['TelephoneNumber'],
        'sanpayCode': json['SanpayCode'],
        'institutionAgentCode': json['InstitutionAgentCode'],
        'telephoneNumberCountryCode': IAPCOUNTRYFromJSON(json['TelephoneNumberCountryCode']),
    };
}

export function BrokerConsultantInformationViewModelToJSON(value?: BrokerConsultantInformationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FirstName': value.firstName,
        'Surname': value.surname,
        'EmailAddress': value.emailAddress,
        'TelephoneNumber': value.telephoneNumber,
        'SanpayCode': value.sanpayCode,
        'InstitutionAgentCode': value.institutionAgentCode,
        'TelephoneNumberCountryCode': IAPCOUNTRYToJSON(value.telephoneNumberCountryCode),
    };
}

